import Vue from 'vue'

const setup = (el, binding, onlyValue) => {
    el.setAttribute('aria-label', binding.value)

    if (onlyValue)
        return

    if (!Object.keys(binding.modifiers).length)
        el.classList.add('hint--top')

    el.classList.add('hint--rounded')

    for (let key of Object.keys(binding.modifiers)) {
        if (key === 'no_animate')
            key = 'no-animate'

        el.classList.add('hint--' + key)
    }
}

const clean = (el, binding) => {
    el.removeAttribute('aria-label')

    if (!Object.keys(binding.modifiers).length)
        el.classList.remove('hint--top')

    el.classList.remove('hint--rounded')

    for (let key of Object.keys(binding.modifiers)) {
        if (key === 'no_animate')
            key = 'no-animate'

        el.classList.remove('hint--' + key)
    }
}

Vue.directive('pml-tooltip', {
    bind (el, binding) {
        if (binding.value)
            setup(el, binding)
    },
    update (el, binding) {
        if (binding.value)
            if (!binding.oldValue)
                setup(el, binding)
            else
                setup(el, binding, true)
        else
            clean(el, binding)
    }
})



// WEBPACK FOOTER //
// ./src/utils/directives/tooltip.js